'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseProps = exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _theme = require('../components/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = exports.propTypes = {
  shadow: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(_theme2.default.shadows.map(function (_, i) {
    return i;
  }))])
};

var parseShadow = function parseShadow(val) {
  var i = Number.isInteger(val) ? val - 1 : 0;
  return (0, _glamor.css)({
    boxShadow: _theme2.default.shadows[i]
  });
};

var parseProps = exports.parseProps = function parseProps(_ref) {
  var shadow = _ref.shadow,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['shadow', 'className']);

  return _extends({
    className: shadow !== undefined ? (0, _classnames2.default)('' + parseShadow(shadow), className) : className
  }, props);
};
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/enhancers/shadow.js
// module id = 1150
// module chunks = 0